import { getDefaultTheme } from "../../utils/tokens";
var tokens = getDefaultTheme();
var IconSizes = {
    s: tokens.icon.size.s,
    m: tokens.icon.size.m,
    l: tokens.icon.size.l,
    xl: tokens.icon.size.l
};
export default IconSizes;
